import { render, staticRenderFns } from "./addUserV2.vue?vue&type=template&id=da84c184&scoped=true"
import script from "./addUserV2.vue?vue&type=script&lang=js"
export * from "./addUserV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84c184",
  null
  
)

export default component.exports